/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Stack, Box } from "@mui/material";
import { DisplayItem, DisplayItemProps } from "components/Common/DisplayItem";
import { FC } from "react";
import { ReactComponent as IconTimer } from "assets/icon_timer.svg";

interface Props extends DisplayItemProps {
  isAutoStart: boolean;
}

/**
 * Component of item display
 * @param {Props} param0 Properties
 * @return {FC} Component
 */
export const DisplayItemWithTimeIcon: FC<Props> = ({
  isAutoStart,
  ...props
}) => {
  return (
    <Stack
      direction="row"
      sx={{
        marginLeft: "-1.5rem",
        alignItems: "center",
        justifyItems: "center",
      }}
    >
      {isAutoStart ? (
        <Box sx={{ width: "1.5rem" }}>
          <IconTimer
            style={{
              width: "1rem",
              height: "1rem",
            }}
          />
        </Box>
      ) : (
        <Box sx={{ width: "1.5rem" }}></Box>
      )}
      <DisplayItem {...props} />
    </Stack>
  );
};
